import { useCallback, useMemo, useState } from 'react';
import { accessAPI } from '../services/api';
import {
  nextExtraPermissionsForPma,
  userHasPmaImportPermission,
} from '../utils/pmaUploaderAccess';

export default function usePmaUploaders(users, onChanged) {
  const [busyId, setBusyId] = useState(null);
  const [error, setError] = useState('');

  const selectedCount = useMemo(
    () => (users || []).filter(userHasPmaImportPermission).length,
    [users]
  );

  const setPmaEnabled = useCallback(
    async (staffUser, enabled) => {
      setError('');
      setBusyId(staffUser.id);
      try {
        await accessAPI.updateUser(staffUser.id, {
          extraPermissions: nextExtraPermissionsForPma(staffUser, enabled),
        });
        await onChanged?.();
      } catch (err) {
        setError(err.response?.data?.message || 'Could not update PMA access');
      } finally {
        setBusyId(null);
      }
    },
    [onChanged]
  );

  return { busyId, error, selectedCount, setPmaEnabled };
}
